module.exports = __webpack_public_path__ + "static/media/logo.5846fa44.svg";